module.exports = __webpack_public_path__ + "static/media/S (208).2f022a1c.jpg";